import { FbListCellRendererClass } from '../../cells/FbListCellRendererClass';
import { FbListCellEditorClass } from '../../cells/FbListCellEditorClass';

import { renderChipsFactory } from '../renderChipsFactory/renderChipsFactory';

export default function listCellService({ FbCellRenderer, FbCellEditor, TYPES: { list } }) {
  const listService = list(); // importación servicio angular
  return function generate(viewField, engineApi, engineGridApi) {
    viewField.metadata = viewField.metadata || {};
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);

    column.type = 'list';
    column.icon = 'bars';

    const renderPopup = renderPopupFactory();
    const renderChipsFn = renderChipsFactory(viewField, engineApi);
    column.renderer = FbListCellRendererClass(FbCellRenderer, {}, { renderChipsFn, renderPopup });
    column.editor = FbListCellEditorClass(FbCellEditor, {}, { renderChipsFn, renderPopup });

    return column;

    // pinta el contenido del popup
    function renderPopupFactory() {
      let template;
      return () => {
        if (!template) {
          template = listService(viewField, engineApi).toString();
        }
        return template;
      };
    }

    // sobreescribe la gestión por defecto del evento click
  };
}
